import { MenuItem, Select } from '@mui/material';
import React from 'react';
import { useAuthStore } from '../../store/storeAuth';
import {
  NotificationType,
  useNotificationStore,
} from '../../store/storeNotifications';
import TagInput from '../Test/TagInput';
import Label from '../UI/Label/Label';
import MicrosoftFileSelect from './MicrosoftFileSelect';

interface PullMicrosoftWordDataProps {
  formData: any;
  onChange: (e: { target: { name: string; value: any } }) => void;
  onChangeSelect: (e: { target: { name: string; value: any } }) => void;
  data: any;
  nodeId: string;
  nodeLabel: string;
}

const PullMicrosoftWordData: React.FC<PullMicrosoftWordDataProps> = ({
  formData,
  onChange,
  onChangeSelect,
  data,
  nodeId,
  nodeLabel,
}) => {
  const { user } = useAuthStore(state => state);
  const setNotification = useNotificationStore(state => state.setNotification);

  const contentType = formData.microsoftWordContentType ?? 'fullContent';

  const searchableSelectSx = {
    '& .MuiList-root': {
      backgroundColor: user?.theme === 'dark' ? '#101828' : '#F9FAFB',
    },
    '& .MuiSvgIcon-root': {
      color: user?.theme === 'dark' ? '#D0D5DD' : '#101828',
    },
    borderRadius: '8px',
    border: 'none',
    boxShadow: 'none',
    '.MuiOutlinedInput-notchedOutline': { border: 0 },
  };

  const selectSx = {
    ...searchableSelectSx,
    marginTop: '20px',
    bgcolor: user?.theme === 'dark' ? '#101828' : '#F9FAFB',
    color: user?.theme === 'dark' ? '#D0D5DD' : '#101828',
  };

  const menuPropsSx = {
    PaperProps: {
      sx: {
        '& .Mui-selected': {
          backgroundColor: user?.theme === 'dark' ? '#667085' : '#D0D5DD',
        },
        backgroundColor: user?.theme === 'dark' ? '#1D2939' : '#F9FAFB',
      },
    },
  };

  return (
    <MicrosoftFileSelect
      fileType="docx"
      fileIdField="microsoftWordFileId"
      label="documents"
      selectLabel="Search or select a Word document"
      onChangeSelect={onChangeSelect}
      data={data}
    >
      <Select
        onChange={e =>
          onChangeSelect({
            target: {
              name: 'microsoftWordContentType',
              value: e.target.value,
            },
          })
        }
        value={contentType}
        name="microsoftWordContentType"
        className="nodrag"
        sx={selectSx}
        MenuProps={menuPropsSx}
      >
        <MenuItem
          value="fullContent"
          sx={{ color: user?.theme === 'dark' ? '#D0D5DD' : 'black' }}
        >
          Full Document
        </MenuItem>
        <MenuItem
          value="pullCert"
          sx={{ color: user?.theme === 'dark' ? '#D0D5DD' : 'black' }}
        >
          Pull Certain Paragraphs
        </MenuItem>
      </Select>

      {contentType === 'pullCert' && (
        <>
          <Label
            labelStyle={{
              fontSize: '14px',
              color: user?.theme === 'dark' ? '#D0D5DD' : '#101828',
              fontWeight: 400,
            }}
            labelName="Paragraphs"
            isAdvanced
          />

          <TagInput
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const value = e.target.value;
              if (value !== '' && (isNaN(+value) || +value < 0)) {
                setNotification({
                  type: NotificationType.Error,
                  message: 'Paragraph Start must be a positive number',
                });
              }
              onChange({ target: { name: 'paragraphStart', value } });
            }}
            placeholder="Paragraph Start"
            value={formData.paragraphStart ?? ''}
            handleId="paragraphStart"
            dataConnected={data?.paragraphStartData || []}
            isAdvanced
            isCollapsed={false}
            labelName="Paragraph Start"
            advancedCollapsed
            handleSettings={{ top: '22px' }}
            type="number"
            name="paragraphStart"
            nodeId={nodeId}
            nodeLabel={nodeLabel}
          />

          <TagInput
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const value = e.target.value;
              if (value !== '' && (isNaN(+value) || +value < 0)) {
                setNotification({
                  type: NotificationType.Error,
                  message: 'Paragraph End must be a positive number',
                });
              }
              onChange({ target: { name: 'paragraphEnd', value } });
            }}
            placeholder="Paragraph End"
            value={formData.paragraphEnd ?? ''}
            handleId="paragraphEnd"
            dataConnected={data?.paragraphEndData || []}
            isAdvanced
            isCollapsed={false}
            labelName="Paragraph End"
            advancedCollapsed
            handleSettings={{ top: '22px' }}
            type="number"
            name="paragraphEnd"
            nodeId={nodeId}
            nodeLabel={nodeLabel}
          />
        </>
      )}
    </MicrosoftFileSelect>
  );
};

export default PullMicrosoftWordData;
